module.exports = __webpack_public_path__ + "static/media/Machinery & Equipment.0ab24612.jpg";